import { Notify, Dialog } from "quasar";
export function onResponseSuccess(response) {
    if (response?.data?.message) {
        Notify.create({
            type: "positive",
            message: response.data.message,
        });
    }
    return response;
}

export function onResponseError(error) {
    const errorResponse = error?.response;
    const responseData = errorResponse?.data;

    if (responseData?.message) {
        Notify.create({
            type: "negative",
            message: responseData.message,
            caption: responseData.slug || "",
        });
    }
    if (responseData?.errorArr) {
        const { errorArr, message } = responseData;
        const errorMessage = Array.isArray(errorArr)
            ? errorArr
                  .map((item) =>
                      typeof item === "object" && item !== null
                          ? Object.entries(item)
                                .map(([k, v]) => `<b>${k}</b>: ${v}`)
                                .join(", ")
                          : item
                  )
                  .join("<br>")
            : Object.entries(errorArr)
                  .map(([key, val]) => {
                      let formattedVal;
                      if (Array.isArray(val)) {
                          formattedVal = val
                              .map((item) =>
                                  typeof item === "object" && item !== null
                                      ? Object.entries(item)
                                            .map(([k, v]) => `${k}: ${v}`)
                                            .join(", ")
                                      : item
                              )
                              .join(" | ");
                      } else {
                          formattedVal = val;
                      }
                      return `<b>${key}</b>: ${formattedVal}`;
                  })
                  .join("<br>");
        Dialog.create({
            title: message,
            message: errorMessage,
            html: true,
            persistent: true,
            ok: {
                label: "Cerrar",
                color: "negative",
            },
        });
    }
    if (import.meta.env.DEV) {
        console.error("API Error:", {
            status: errorResponse?.status,
            message: errorResponse?.data?.detail || error.message,
            url: errorResponse?.config?.url,
        });
    }

    if (errorResponse) {
        switch (errorResponse.status) {
            case 401: {
                // window.location.href = '/login'
                break;
            }
            case 403: {
                // Mostrar mensaje de permisos insuficientes
                break;
            }
            case 404: {
                // Recurso no encontrado
                break;
            }
            case 422: {
                break;
            }
            case 500: {
                // Error del servidor
                break;
            }
            default: {
                break;
            }
        }
    }

    return Promise.reject(errorResponse ?? error);
}
